import React, {useContext} from 'react'
import {Alert} from "antd";
import {Context} from "../../store"

// Settings menu permissions, copied from the Windows app (frmHome.cs, frmHome_Load):
//   administrator: Administrator menu (Item, Rate Plan, Daily Rate, Room, System User, Client,
//                  Company, Staff, Supplier) and Settings menu (Property, System Setting, Devices)
//   manager:       Administrator menu only
//   supervisor:    Supervisor menu (Item, Rate Plan, Daily Rate, Client, Supplier)
//   cashier:       none
// In web, Room is "Resource" and Client/Company/Staff/Supplier are "Parties".

function currentRole(role) {
    if(role !== undefined && role !== null && role !== '')
    {
        return role;
    }

    let r = localStorage.getItem('role');
    try
    {
        return JSON.parse(r);
    }
    catch (err)
    {
        return r;
    }
}

export function settingsAccess(role) {
    role = currentRole(role);

    let admin = role === 'administrator';
    let manager = role === 'manager';
    let supervisor = role === 'supervisor';

    return {
        property: admin,
        systemsettings: admin,
        item: admin || manager || supervisor,
        rateplan: admin || manager || supervisor,
        dailyrate: admin || manager || supervisor,
        resource: admin || manager,
        systemuser: admin || manager,
        party: admin || manager || supervisor,
        partyTypes: supervisor ? ['client', 'supplier'] : ['client', 'staff', 'supplier', 'company'],
        showMenu: admin || manager || supervisor
    };
}

// Wraps a Settings page so typing its address does not get past the menu rule.
export function SettingsGuard(props) {
    const [state] = useContext(Context)

    if(settingsAccess(state.role)[props.page] === true)
    {
        return props.children;
    }

    return (
        <div style={{padding: '20px'}}>
            <Alert type="error" showIcon message="You do not have access to this page." />
        </div>
    );
}
